import React from 'react';

import { Plus } from 'lucide-react';

import RegistrationWrapper from 'common/canny/register/RegistrationWrapper';
import VStack from 'common/ui/VStack';
import Button from 'common/uiV3/Button';
import Input from 'common/uiV3/Input';

type Props = {
  inviteEmails: string[];
  onChangeInviteEmails: (inviteEmails: string[]) => void;
  onSubmit: () => void;
};

const AdminOnboardingInvite = ({ inviteEmails, onChangeInviteEmails, onSubmit }: Props) => {
  const onEmailChange = (index: number, email: string) => {
    const newEmails = [...inviteEmails];
    newEmails[index] = email;
    onChangeInviteEmails(newEmails);
  };

  const addEmailRow = () => onChangeInviteEmails([...inviteEmails, '']);

  const onKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSubmit();
    }
  };

  return (
    <RegistrationWrapper.Content className="gap-6">
      <RegistrationWrapper.Header>
        <RegistrationWrapper.Title>Invite your team</RegistrationWrapper.Title>
        <RegistrationWrapper.Description>
          Collaborate with your teammates to get the most out of Canny.
        </RegistrationWrapper.Description>
      </RegistrationWrapper.Header>
      <VStack className="gap-2 max-w-[600px]">
        <p className="text-lg">Invite with email</p>
        {inviteEmails.map((email, index) => {
          return (
            <Input
              key={index}
              onChange={(emailValue) => onEmailChange(index, emailValue)}
              onKeyUp={onKeyUp}
              placeholder="Email address"
              value={email}
              size="large"
            />
          );
        })}
        <Button onClick={addEmailRow} variant="plain" size="large" className="self-start">
          <Plus />
          Add more
        </Button>
      </VStack>
    </RegistrationWrapper.Content>
  );
};

export default AdminOnboardingInvite;
